import React from 'react'
import RbacMenuList from '../../../components/rbac/menu/RbacMenuList';

const RbacMenu = () => {
  return <RbacMenuList />
}

export default RbacMenu;
